export class Abstracts {
  author: string;
  link: string;
  affiliation: string;
  title: string;
  abstract: string;


  constructor(author: string, link: string, affiliation: string, title: string, abstract: string) {
    this.author = author;
    this.link = link;
    this.affiliation = affiliation;
    this.title = title;
    this.abstract = abstract;
  }
}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/model/Abstracts.ts